"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=permission.types.js.map